import { FaInfoCircle } from 'react-icons/fa';

/**
 * @param {{ yard: { Yard: number, City?: string, State?: string }, reason?: 'no-coords' }} props
 */
export default function UnavailablePlaceholder({ yard, reason }) {
  const subline =
    reason === 'no-coords'
      ? 'Map data not configured for this facility.'
      : `Yard ${yard.Yard}${yard.City ? ` — ${yard.City}, ${yard.State}` : ''}`;

  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-50">
      <div className="text-center bg-white border border-gray-200 rounded-lg shadow-sm p-10 max-w-md">
        <FaInfoCircle className="text-4xl text-gray-400 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Detailed map layout currently unavailable for this facility
        </h2>
        <p className="text-sm text-gray-500">{subline}</p>
      </div>
    </div>
  );
}
